<template>
       <textarea
           ref="input"
           class="mt-1 block w-full appearance-none rounded border border-gray-200 px-3 py-2.5 placeholder-gray-400 shadow-sm focus:border-gray-600 focus:outline-none focus:ring-0 bg-gray-50 focus:bg-white text-sm"

           />
</template>
